export default __webpack_public_path__ + "static/media/page-not-found-g806f85362_1280.c052543c.png";